// extracted by mini-css-extract-plugin
export default {"root":"fY5TeBvtaoF8dk5UHffw","link":"ERIb8zSV_2pGJ7p3GqRc","btn":"Dd8JNKsrq64n0qk_hGU2"};